<template>
    <Teleport to="#tooltips-container">
        <div
            v-if="show"
            class="absolute top-0 left-0 bg-white w-25 rounded py-2 shadow-radio-card text-[14px] leading-[17px] text-won-dark-blue z-[9999]"
            :style="menuPositionStyles"
            ref="menuRef"
        >
            <div
                class="flex items-center gap-2 py-1 px-3 hover:bg-[#DBDBDC] cursor-pointer"
                @click="cutHandler"
            >
                <ScissorsIcon class="size-4 text-won-dark-blue"/>
                <span>Cut</span>
            </div>

            <div
                class="flex items-center gap-2 py-1 px-3 hover:bg-[#DBDBDC] cursor-pointer"
                @click="copyHandler"
            >
                <ClipboardIcon class="size-4 text-won-dark-blue"/>
                <span>Copy</span>
            </div>

            <div
                class="flex items-center gap-2 py-1 px-3 hover:bg-[#DBDBDC] cursor-pointer"
                @click="pasteHandler"
            >
                <DocumentDuplicateIcon class="size-4 text-won-dark-blue"/>
                <span>Paste</span>
            </div>

            <div
                class="flex items-center gap-2 py-1 px-3 hover:bg-[#DBDBDC] cursor-pointer"
                @click="deleteHandler"
            >
                <TrashIcon class="size-4 text-won-dark-blue"/>
                <span>Delete</span>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
import { ref, toRefs, computed, Teleport } from "vue";
import { storeToRefs } from "pinia";
import { onClickOutside } from "@vueuse/core";

import { useMousePosition } from "../../store/mouse-position.store";
import { useTiptapStore } from "../../store/tiptap.store";

import {
    ClipboardIcon,
    TrashIcon,
    DocumentDuplicateIcon,
    ScissorsIcon
} from "@heroicons/vue/24/solid"

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    hideContextMenu: {
        type: Function,
        default: () => {}
    }
})
const { show, hideContextMenu } = toRefs(props)

const mousePositionStore = useMousePosition()
const { posX, posY } = storeToRefs(mousePositionStore)

const tiptapStore = useTiptapStore();
const { editor } = storeToRefs(tiptapStore);

const menuRef = ref(null)

onClickOutside(menuRef, hideContextMenu.value)

const menuPositionStyles = computed(() => {
    return { transform: `translate(${posX.value}px, ${posY.value}px)` }
})

const copyHandler = () => {
    editor.value.chain().focus().copy().run();
    hideContextMenu.value()
}

const cutHandler = async () => {
    editor.value.chain().focus().cut().run();
    hideContextMenu.value()
}

const pasteHandler = () => {
    editor.value.chain().focus().paste().run();
    hideContextMenu.value()
}

const deleteHandler = () => {
    editor.value.commands.deleteSelection()
    hideContextMenu.value()
}
</script>
